// extracted by mini-css-extract-plugin
export default {"webspace-select":"webspace-select--0UMCDp5am1","webspaceSelect":"webspace-select--0UMCDp5am1"};